// import components
import { alpha, Box, styled } from '@mui/material';

// import constants
import { FIRST_CELL_WIDTH } from '../const';

// import utils
import { rSize } from 'components/utils';

export const RosterViewByEmployee = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: rSize(30),
  boxSizing: 'border-box',

  '& h3': {
    marginTop: 0
  },

  '& .roster-grid': {
    tableLayout: 'fixed',

    '& th, & td': {
      border: 0,
      padding: theme.spacing(1),
      verticalAlign: 'top',
      position: 'relative',
      textAlign: 'center',
      boxSizing: 'border-box'
    },

    '& th': {
      padding: theme.spacing(4),
      lineHeight: '20px',
      whiteSpace: 'nowrap'
    },

    '& td': {
      border: '1px dashed #ccc',
      height: '49px',

      '&:first-child': {
        borderLeft: 0
      },
      '&:last-child': {
        borderRight: 0
      }
    },

    '& tr:not(:first-child)': {
      '& td:not(:last-child):not(:first-child)::after': {
        content: '""',
        position: 'absolute',
        zIndex: 2,
        width: '6px',
        height: '6px',
        right: 0,
        top: 0,
        transform: 'translate(50%, -50%)',
        backgroundColor: theme.palette.background.default
      },
      '& td:nth-child(2)::before': {
        content: '""',
        position: 'absolute',
        zIndex: 2,
        width: '6px',
        height: '6px',
        left: 0,
        top: 0,
        transform: 'translate(-50%, -50%)',
        backgroundColor: theme.palette.background.default
      }
    },

    '& thead tr:first-child th:first-child, & td:first-child': {
      width: FIRST_CELL_WIDTH,
      textAlign: 'left',
      paddingBottom: 0
    },

    '& thead tr:last-child th': {
      padding: '5px 0px'
    },

    '& tr:first-child td': {
      borderTop: 0
    },

    '& tr:last-child td': {
      borderBottom: 0
    },

    '& .is-sunday:not(:last-child)': {
      borderRight: `1px dashed ${theme.palette.primary.main}`,
      '&::before, &::after': {
        display: 'none'
      }
    },

    '& tbody tr:first-child td': {
      paddingTop: 0
    },
    '& tbody tr:last-child td': {
      paddingBottom: 0
    },
    '& tbody tr:not(.no-highlight)': {
      '& td': {
        transition: 'background-color 0.15s ease-in-out 0.1s'
      },
      '&:hover td': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08)
      }
    },

    '& .display-contents': {
      display: 'flex',

      '& .duty, & .absence': {
        minWidth: '100%',
        justifyContent: 'inherit',

        '& .code-label': {
          marginTop: theme.spacing(2)
        }
      },

      '&:last-child .duty, &:last-child .absence': {
        marginBottom: 0
      }
    },

    '& .function-container': {
      position: 'relative',
      lineHeight: '21px',

      '& .function-color': {
        position: 'absolute',
        left: '-10px',
        top: 0,
        height: '100%',
        display: 'flex',
        alignItems: 'center',

        '& svg': {
          width: '6px',
          height: '6px'
        }
      }
    },

    '& .is-weekend': {
      backgroundColor: alpha(theme.palette.divider, 0.04)
    },

    '& .is-today': {
      backgroundColor: alpha(theme.palette.primary.main, 0.08)
    },

    '& .is-yesterday, & .is-today, & .is-friday, & .is-weekend': {
      '&::before, &::after': {
        display: 'none'
      }
    }
  },

  '& .MuiAccordionSummary-root': {
    width: FIRST_CELL_WIDTH,
    paddingRight: `calc(100% - ${FIRST_CELL_WIDTH}) !important`,
    paddingLeft: '0 !important',
    justifyContent: 'center !important'
  },

  '& .roster-body': {
    position: 'relative',
    flexGrow: 1,
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'scroll',
    overflowX: 'hidden',

    '& .wrap-container': {
      position: 'relative',
      display: 'block',
      paddingRight: theme.spacing(8)
    }
  },

  '&:not(.is-accordion)': {
    '& .header': {
      marginBottom: theme.spacing(5)
    },
    '& .employees-container:not(:last-child)': {
      marginBottom: theme.spacing(5)
    },
    '& .open-requests-container': {
      marginTop: theme.spacing(5)
    }
  },

  '& .search .MuiInput-root': {
    marginTop: theme.spacing(7.5)
  }
}));

export default RosterViewByEmployee;
